module.exports = __webpack_public_path__ + "media/images/webpage/clips/serial-d7589a7672eda58c72544a918a192609.webp";